import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import vars from '@exo/narrative-tracker-variables';

var bounce = keyframes(["0%,80%,100%{transform:scale(0);}40%{transform:scale(1.0);}"]);

var Base = styled.span.withConfig({
	displayName: "DotSpinner__Base",
	componentId: "sc-enm8uf-0"
})(["display:block;position:absolute;height:18px;width:100px;top:50%;left:50%;margin:-9px 0 0 -50px;"]);
var Bounce3 = styled.span.withConfig({
	displayName: "DotSpinner__Bounce3",
	componentId: "sc-enm8uf-1"
})(["display:inline-block;width:18px;height:18px;margin:0 7px;background-color:", ";border-radius:50%;animation:", " 1.4s infinite ease-in-out both;"], vars.accent, bounce);
var Bounce1 = styled(Bounce3).withConfig({
	displayName: "DotSpinner__Bounce1",
	componentId: "sc-enm8uf-2"
})(["animation-delay:-0.32s;"]);
var Bounce2 = styled(Bounce3).withConfig({
	displayName: "DotSpinner__Bounce2",
	componentId: "sc-enm8uf-3"
})(["animation-delay:-0.16s;"]);

var DotSpinner = function DotSpinner(props) {
	return React.createElement(
		Base,
		{ style: { transform: "scale(" + props.scale + ")" } },
		React.createElement(Bounce1, { style: { backgroundColor: props.color } }),
		React.createElement(Bounce2, { style: { backgroundColor: props.color } }),
		React.createElement(Bounce3, { style: { backgroundColor: props.color } })
	);
};

DotSpinner.defaultProps = {
	color: "#000",
	scale: 1
};

DotSpinner.propTypes = {
	color: PropTypes.string,
	scale: PropTypes.number // n or n.n  1 = 18px by 100px
};

export default DotSpinner;
//# sourceMappingURL=index.es.js.map
